module.exports = __webpack_public_path__ + "img/background.4ba61447.png";